module.exports = __webpack_public_path__ + "img/live.0f843925.png";